import { Component, ViewChild, ElementRef, Input } from '@angular/core';

export enum TooltipSizes {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

export enum TooltipPositions {
  ABOVE = 'above',
  BELOW = 'below',
  LEFT = 'left',
  RIGHT = 'right',
}

export enum TooltipVariations {
  PRIMARY = 'primary',
  INVERSE = 'inverse',
}

export enum TooltipOrientations {
  CENTER = 'center',
  LEFT = 'left',
  RIGHT = 'right',
}

@Component({
  moduleId: module.id,
  selector: 'basic-tooltip',
  templateUrl: './basic-tooltip.component.html',
})
export class BasicTooltipComponent {
  isLeftOffScreen = false;
  isRightOffScreen = false;

  @Input() size: TooltipSizes | string = TooltipSizes.MEDIUM;
  @Input() position: TooltipPositions | string = TooltipPositions.BELOW;
  @Input() variation: TooltipVariations | string = TooltipVariations.PRIMARY;
  @Input() orientation: TooltipOrientations | string = TooltipOrientations.CENTER;
  @Input() allowAutoOrientation: boolean = false;
  @Input() noLabelStyling = false;
  @Input() removeNubbin = false;

  @ViewChild('tip') tipRef: ElementRef<HTMLElement>;
  @ViewChild('tipContent') tipContentRef: ElementRef<HTMLElement>;

  checkOffScreen() {
    const tipElement = this.tipRef.nativeElement;
    const tipContent = this.tipContentRef.nativeElement;
    const { left: tipElementLeft } = tipElement.getBoundingClientRect();
    const { width: tipContentWidth } = tipContent.getBoundingClientRect();
    const { right: bodyRight } = document.body.getBoundingClientRect();

    this.isLeftOffScreen = tipElementLeft < tipContentWidth / 2;
    this.isRightOffScreen = tipElementLeft + tipContentWidth / 2 > bodyRight;

    // allowAutoOrientation flag was added to not break anyone elses
    // use of the tooltip. Passing True to allowAutoOrientation
    // will prevent the tooltip from going off screen (useful for things like mobile etc)
    if (this.allowAutoOrientation) {
      // if tool tip ever goes off the screen it gets corrected
      if (this.isLeftOffScreen) {
        this.orientation = TooltipOrientations.RIGHT;
      }

      if (this.isRightOffScreen) {
        this.orientation = TooltipOrientations.LEFT;
      }
    }
  }
}
